import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiAbstraction } from './api.abstraction';
import { Observable } from 'rxjs';

@Injectable()
export class ReportApi extends ApiAbstraction {
  public constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  public reports(body: ReportInputDAO): Observable<unknown> {
    return this.httpClient.post(`${this.baseUrl}/reports`, body);
  }
}
